import type { MgmtSearch, MgmtTab } from "./MgmtPerformanceView";

const TABS: readonly MgmtTab[] = ["tree", "cluster", "branch", "branch_manager", "shift_lead"];

/** `?tab=&cluster=&branch=&month=` — giá trị lạ thì bỏ qua, không làm hỏng trang. */
export function parseMgmtSearch(search: Record<string, unknown>): MgmtSearch {
  const out: MgmtSearch = {};
  if (typeof search.tab === "string" && (TABS as readonly string[]).includes(search.tab))
    out.tab = search.tab as MgmtTab;
  if (typeof search.cluster === "string" && search.cluster) out.cluster = search.cluster;
  if (typeof search.branch === "string" && search.branch) out.branch = search.branch;
  if (typeof search.month === "string" && /^\d{4}-\d{2}$/.test(search.month))
    out.month = search.month;
  return out;
}
